function About (){
    return(
        <div className="about">
            <h2 className="header"> About Our Website </h2>
            <div className="pContainer">
                <p>If you're feeling down check out our website. We understand what it's like to have rough days. Our main focuse is to lift up your spirits with compliments and puppy photos.  
                </p>
                <p> The website uses a compliment API and a puppy API in a react website. Visit our <a href="https://github.com/bavila19/project-two" ><span>GitHub link</span></a>.
                </p>
                <p>With peace and love, we hope you have a wonderful day.</p>
            </div>
            
        </div>
    )
}

export default About